import { ROLES } from '@/utils/constants';
export default {
  data() {
    return {
      financialSummaryLoading: false,
      financialSummaryError: false,
      financialSummaryItems: {
        lateTotal: null,
        paidTotal: null,
        toExpireTotal: null,
      },
    };
  },
  methods: {
    async getFinancialSummary() {
      try {
        if (this.user.userRole !== ROLES.CLIENT_ROLE) return;
        if (this.financialSummaryLoading) return;
        this.financialSummaryError = false;
        this.financialSummaryLoading = true;

        const contract = this.selectedUnit.contracts.find((o) => o.isValid);
        const params = {
          contractId: contract.id,
          contractType: contract.type,
          productCode: this.selectedUnit.product.code,
          blockCode: this.selectedUnit.block.code,
          unitCode: this.selectedUnit.unit.code,
          onlyTotal: 1,
        };

        const result = await this.requestService(
          process.env.FINANCIAL_POSITION_API_URL,
          'GET',
          { params, localErrorHandling: true, retries: 0 }
        );

        if (result) {
          this.financialSummaryItems.lateTotal = this.formatMoney(
            result.lateTotal
          );
          this.financialSummaryItems.toExpireTotal = this.formatMoney(
            result.toExpireTotal
          );
          this.financialSummaryItems.paidTotal = this.formatMoney(
            result.paidTotal
          );
        }
      } catch (err) {
        this.financialSummaryError = true;
      } finally {
        this.financialSummaryLoading = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/modules/financialSummary.js